import React from "react";
import { Modal } from "@mantine/core";

const ModalComponent = ({ opened, setOpened, children, size, onClose }) => {
  const handleClose = () => {
    if (onClose && typeof onClose === 'function') {
      onClose();
    } else if (setOpened && typeof setOpened === 'function') {
      setOpened(false);
    }
  };

  return (
    <>
      <Modal
        transitionProps={{ transition: "fade", duration: 200, timingFunction: "linear" }}
        radius="lg"
        // overflow="inside"
        centered
        style={{ minWidth: 320 }}
        size={size}
        opened={opened}
        onClose={handleClose}
      >
        {children}
      </Modal>
    </>
  );
};

export default ModalComponent;
